import React from 'react';
import { Link } from 'react-router-dom';
import { Trophy, ArrowRight } from 'lucide-react';
import { prizeDraw } from '../data/prizeDraw';

// Slim homepage banner, sits directly under the hero
export const PrizeDrawBanner = () => (
  <div className="bg-[#0b1220] border-y border-white/10" data-testid="prize-draw-banner">
    <div className="max-w-7xl mx-auto px-4 py-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-center">
      <Link
        to="/win-your-move"
        className="group inline-flex items-center gap-2 sm:gap-3"
        data-testid="prize-draw-banner-link"
      >
        <Trophy className="w-4 h-4 text-amber-400 flex-shrink-0" />
        <span className="text-sm text-gray-200">{prizeDraw.teaser}</span>
        <ArrowRight className="w-4 h-4 text-emerald-400 flex-shrink-0 transition-transform group-hover:translate-x-1" />
      </Link>
      <Link
        to="/prize-draw-terms"
        className="text-xs text-gray-400 underline decoration-dotted hover:text-white transition-colors"
        data-testid="prize-draw-banner-terms-link"
      >
        T&amp;Cs apply
      </Link>
    </div>
  </div>
);

// One-line mention for use near a call CTA on inner pages
export const PrizeDrawLine = ({ className = '', theme = 'dark', testId = 'prize-draw-line' }) => {
  const isDark = theme === 'dark';
  return (
    <p className={`text-sm ${isDark ? 'text-gray-300' : 'text-gray-600'} ${className}`} data-testid={testId}>
      <Trophy className={`w-4 h-4 inline-block mr-2 -mt-0.5 ${isDark ? 'text-amber-400' : 'text-amber-500'}`} />
      Book this month and you&apos;re entered into our monthly prize draw - win your move back, up to £500.{' '}
      <Link
        to="/win-your-move"
        className={`font-semibold underline decoration-dotted ${isDark ? 'text-emerald-400' : 'text-[#3B43AF]'}`}
        data-testid={`${testId}-link`}
      >
        How it works
      </Link>{' '}
      <Link
        to="/prize-draw-terms"
        className={`${isDark ? 'text-gray-400' : 'text-gray-500'} underline decoration-dotted`}
        data-testid={`${testId}-terms-link`}
      >
        T&amp;Cs apply
      </Link>
    </p>
  );
};

export default PrizeDrawBanner;
